export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api/v1';
export const OAUTH_BASE_URL = process.env.REACT_APP_OAUTH_BASE_URL || '';
